import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getEnquirie } from "../../store/actions/enquiries_action";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/enquiries_enum";
import SingleView from "../../components/common/SingleView";
const ViewEnquirie = ({
  getEnquirie,
  match,
  enquirie: { loading, enquirie },
}) => {
  useEffect(() => {
    getEnquirie(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          enquirie && (
            <SingleView
              data={enquirie}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={enquirie.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ enquirie: state.enquirie });

const mapDispatchToProps = { getEnquirie };

export default connect(mapStateToProps, mapDispatchToProps)(ViewEnquirie);
